// import './wdyr';

import { ApolloClient, ApolloProvider, InMemoryCache } from '@apollo/client';
import { useJsApiLoader } from '@react-google-maps/api';
import React, { useRef, useState } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { createGlobalStyle, ThemeProvider } from 'styled-components/macro';
import { normalize } from 'styled-normalize';
import Banner from './components/Banner';
import LocationContext, { Coords, Filters, SiteSettingsProps } from './components/Context';
import Error from './components/Error';
import Landing from './components/Landing';
import { Map } from './components/Map';
import { Search } from './components/Search';
import SiteSettings from './components/SiteSettings';
// import Debug from './components/Debug';

const client = new ApolloClient({
    uri: process.env.REACT_APP_GRAPHQL_ENDPOINT || `${window.location.origin}/graphql`,
    cache: new InMemoryCache(),
});

const theme = {
    colors: {
        brand: '#046a38',
        alt: '#009fe3',
        copy: '#222222',
        dark: '#222222',
        grey: '#E7E7E7',
        lightGrey: '#EEEEEE',
        white: '#fff',
    },
    typography: {
        fontFamily: `'Veneer', sans-serif`,
        base: '14px',
        heading: {
            sm: '36px',
            lg: '38px',
        },
        subHeading: {
            sm: '24px',
            lg: '32px',
        },
        tagline: {
            sm: '16px',
            lg: '16px',
        },
    },
    appHeight: {
        sm: '550px',
        lg: '450px',
    },
    breakpoints: {
        sm: 768,
        lg: 992,
    },
    space: {
        sm: '24px',
        lg: '48px',
    },
};

const GlobalStyle = createGlobalStyle`
${normalize}
body {
  margin: 0;
  * {
    box-sizing: border-box;
  }


}

[data-reach-dialog-overlay] {
    z-index: 101;
    background-color: rgba(0, 0, 0, 0.8);
}
.stockist-app {
    min-width: 320px;
    min-height: 430px;
    display: flex;
    flex-direction: column;
   font-family: Arial, sans-serif;
    /* @media(min-width: 768px) {
        min-height: 860px;
    } */
    pre,code {
    font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',  monospace;
}

a {
    color: #222;
}


}

`;
// Base url user for router
function App({ baseUrl }) {
    // User selected Lat lng
    const [selectedLatLng, setSelectedLatLng] = useState<Coords>();
    // User selected filters
    const [filters, setFilters] = useState<Filters>({});
    // The selected location in words e.g Brighton
    const [selectedDescription, setSelectedDescription] = useState<string>();
    // The Type of Search performed
    const [searchType, setSearchType] = useState<'GEO' | 'SEARCHED' | 'AREA' | 'DEFAULT'>('DEFAULT');
    // The Marker/stockist the user selected
    const [selectedMarker, setSelectedMarker] = useState();
    // Site settings
    const [siteSettings, setSiteSettings] = useState<SiteSettingsProps>();
    const [appHeight, setAppHeight] = useState<number>();

    // The libraries needed for Google maps
    // Ref to stop rerender
    const libraries = useRef<any[]>(['places']);

    const { isLoaded, loadError } = useJsApiLoader({
        googleMapsApiKey: 'AIzaSyBhMVzPI9COJqvjm2sAMXzHmECzEsfosZ4', // production
        // googleMapsApiKey: 'AIzaSyDyeijbb0LdUOTcfV-zCC_prpeoP73_t64', // local    
        libraries: libraries.current,
    });

    return (
        <ApolloProvider client={client}>
            <ThemeProvider theme={theme}>
                <LocationContext.Provider
                    value={{
                        selectedLatLng,
                        setSelectedLatLng,
                        selectedDescription,
                        setSelectedDescription,
                        searchType,
                        setSearchType,
                        filters,
                        setFilters,
                        selectedMarker,
                        setSelectedMarker,
                        siteSettings,
                        setSiteSettings,
                        appHeight,
                        setAppHeight,
                    }}
                >
                    <GlobalStyle />
                    <SiteSettings>
                        <Banner
                            stockistsMessage={siteSettings?.stockistsMessage}
                            showStockistsMessage={siteSettings?.showStockistsMessage}
                        />
                        {loadError && <Error error="Error Loading Map" />}
                        {isLoaded && !loadError && (
                            <Router basename={baseUrl}>
                                <Switch>
                                    <Route exact path="/">
                                        <Landing>
                                            <Search />
                                        </Landing>
                                    </Route>
                                    <Route path="/map">
                                        <Map />
                                    </Route>
                                </Switch>
                            </Router>
                        )}
                    </SiteSettings>
                    {/* <Debug /> */}
                </LocationContext.Provider>
            </ThemeProvider>
        </ApolloProvider>
    );
}

export default App;
